import { combineReducers } from 'redux';

import menu from './sidebarMenu/reducer';

export default combineReducers({
  menu,
});
